export default {
  mounted () {
    // Reset the header when the view mounts
    let objectHeaderContent = window.document.getElementById('objectHeaderContentHidden');
    let objectHeader = window.document.getElementById('objectHeader');
    let pageTitle = window.document.getElementById('pageTitle');

    if (objectHeaderContent && objectHeaderContent.innerHTML !== '') {
      if (typeof this.list !== 'undefined') {
        if (objectHeaderContent && objectHeaderContent.innerHTML !== '' && objectHeader && pageTitle) {
          objectHeader.innerHTML = objectHeaderContent.innerHTML;
          pageTitle.classList.add('md-hide');
          objectHeader.classList.remove('md-hide');
        }

      }
      return;
    }

    if (objectHeader && pageTitle) {
      objectHeader.classList.add('md-hide');
      pageTitle.classList.remove('md-hide');
      objectHeader.innerHTML = '';

    }
  }
}